<template>
	<Toast/>
	<div class="login-body">

		<Dialog header="CI tradicional" v-model:visible="display1" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
			<p>
				Ingresa los datos del dorso de tu documento:
			</p>
			<div class="p-grid p-jc-center">
				<div class="p-col-12">
					<img src="assets/layout/images/auth/ci-trad.png" alt="ci chip" style="width: 100%"/>
				</div>
			</div>
			<template #footer>
				<Button label="Entendido" @click="close1" icon="pi pi-check" class="p-button-secondary"/>
			</template>
		</Dialog>

		<Dialog header="CI con chip" v-model:visible="display2" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
			<p>
				Ingresa los datos del dorso de tu documento:
			</p>
			<div class="p-grid p-jc-center">
				<div class="p-col-12">
					<img src="assets/layout/images/auth/ci-chip.png" alt="ci chip" style="width: 100%"/>
				</div>
			</div>
			<template #footer>
				<Button label="Entendido" @click="close2" icon="pi pi-check" class="p-button-secondary"/>
			</template>
		</Dialog>

		<div class="login-wrapper">
			<div class="login-panel">
				<img src="assets/layout/images/logo-mides.svg" class="logo" alt="tuMides-layout" style="height: 90px !important"/>

				<div class="login-form">
					<h2>Hola, selecciona como ingresar</h2>
					<p>Ingresa con tu CI, con usuario gub.uy u otro proveedor de identidad digital </p>
					<!-- <Button label="Ingresar" type="button" style="width: 100%" @click="login"></Button> -->
					<div class="p-grid p-flex-column">
						<div class="p-col">
							<SelectButton v-model="authvalue" :options="options"/>
						</div>
					</div>
					
					<div id="ci-trad" class="p-grid p-jc-center" v-if="authvalue=='CI tradicional'">
						<div class="p-col-12">
							<InputText id="numci2" placeholder="Ingresa tu cédula de identidad" style="width: 100%" v-model="ci2" :maxlength="8" @keypress="isNumber($event)" @keydown.enter.prevent = ""/>
						</div>
						<div class="p-col-5">
							<InputText id="serie" placeholder="Serie" style="width: 100%" v-model="serie" :maxlength="1"/>
						</div>
						<div class="p-col-5">
							<InputText id="folio" placeholder="N° de folio" style="width: 100%" v-model="folio" :maxlength="6" @keypress="isOnlyNumber($event)" @keydown.enter.prevent = ""/>
						</div>
						<div class="p-col-2">
							<Button icon="pi pi-question" class="p-button-rounded p-button-info p-button-outlined p-mr-2 p-mb-2" @click="open1"/>
						</div>
						<div class="p-col-12">
							<Button label="Ingresar" type="button" style="width: 100%" @click="login"></Button>
						</div>
					</div>

					<div id="ci-chip" class="p-grid p-jc-center" v-if="authvalue=='CI con chip'">
						<div class="p-col-12">
							<InputText id="numci1" placeholder="Ingresa tu cédula de identidad" style="width: 100%" v-model="ci1" :maxlength="8" @keypress="isNumber($event)" @keydown.enter.prevent = ""/>
						</div>
						<div class="p-col-10">
							<InputText id="id" placeholder="Identificador dorso del documento" style="width: 100%" v-model="id" :maxlength="9"/>
						</div>
						<div class="p-col-2">
							<Button icon="pi pi-question" class="p-button-rounded p-button-info p-button-outlined p-mr-2 p-mb-2" @click="open2"/>
						</div>
						<div class="p-col-12">
							<Button label="Ingresar" type="button" style="width: 100%" @click="login"></Button>
						</div>
					</div>

					<div id="id-uruguay" class="p-grid p-jc-center" v-if="authvalue=='ID Uruguay'" style="width: 100%">
						<div class="p-col-12">
							<Button label="Ingresar" type="button" style="width: 100%" @click="login"></Button>					
						</div>
					</div>
				</div>

				<div id="ci-trad" class="p-grid p-jc-center" v-if="ambiente=='local' || ambiente=='integracion'">
					<Divider />
					<div class="p-col-12">
						<InputText id="numci" placeholder="Cédula de identidad a sesionar" style="width: 100%" v-model="ci"/>
					</div>
					<div class="p-col-6">
						<InputText id="usuario" placeholder="Usuario" style="width: 100%" v-model="user"/>
					</div>
					<div class="p-col-6">
						<!-- <InputText id="password" placeholder="Contraseña" style="width: 100%" v-model="pass"/> -->
						<Password id="password" placeholder="Contraseña" v-model="pass" toggleMask  :feedback="false"></Password>
					</div>
					<div class="p-col-12">
						<Button label="Sesionar CI" type="button" style="width: 100%" @click="loginTecnico()"></Button>
					</div>
				</div>

				<p>Por más información llamar al <a href="tel:08007263">0800 72 63</a></p>
			</div>
			<div class="login-image">
				<div class="login-image-content">
					<h1>Bienvenido</h1>
					<h1>a tuMides</h1>
					<h3>
						El servicio facilita y agiliza el acceso<br />
						a información de beneficios activos, postulaciones <br />
						y estado de solicitudes, entre otros.
					</h3>
				</div>
				<div class="image-footer">
					<p>Ministerio de Desarrollo Social de Uruguay</p>
					<div class="icons">
						<a href="https://www.facebook.com/midesuy" target="_blank"><i class="pi pi-facebook"></i></a>
						<a href="https://twitter.com/midesuy" target="_blank"><i class="pi pi-twitter"></i></a>
						<a href="https://youtube.com/midestv" target="_blank"><i class="pi pi-youtube"></i></a>
						<a href="https://www.instagram.com/midesuy/" target="_blank"><i class="pi pi-instagram"></i></a>
						<a href="https://www.linkedin.com/company/ministerio-de-desarrollo-social-de-uruguay-mides-/" target="_blank"><i class="pi pi-linkedin"></i></a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
	<div align="center">
        <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
       </div>
	</Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
export default {
	name: "Login",
	data(){
		return{
            wait: false,
			ambiente: "",
			ci: "",
			user: "",
			pass: "",
			display1: false,
			display2: false,
			authvalue: 'CI con chip',
            options: ['CI tradicional', 'CI con chip', 'ID Uruguay'],
			ci1:null,
			id:"",
			ci2:null,
            serie:"",
			folio:"",
			recaptchaToken: ""
		}
	},
	smartService: null,
    created() {
         this.smartService = new SmartService();
    },	
	mounted() {
		this.smartService.setAmbiente();
        this.ambiente = localStorage.ambiente;
	},
	methods: {
			async obtenerTokenRecaptcha() {
				if (!window.grecaptcha || typeof window.grecaptcha.execute !== "function"
					) {
					throw new Error("reCAPTCHA no se encuentra disponible");
				}

				await new Promise(resolve => {
					window.grecaptcha.ready(resolve);
				});

				return await window.grecaptcha.execute(
					"6Le9fqskAAAAAPjCRyhHRGrL_V8i2Us7lccFhXh1",
					{
					action: "login"
					}
				);
			},
			open1() {
				this.display1 = true;
			},
			close1() {
				this.display1 = false;
			},
			open2() {
				this.display2 = true;
			},
			close2() {
				this.display2 = false;
			},
			isNumber(evt) {
				const charCode = evt.which ? evt.which : evt.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {  
					evt.preventDefault();  
				}  
			},
			isOnlyNumber(evt) {
				const charCode = evt.which ? evt.which : evt.keyCode;
				if (charCode > 31 && (charCode < 48 || charCode > 57)) {
					evt.preventDefault();
				}
			},
			async login(){
				this.wait= true;
				const requiereCaptcha = this.authvalue === "CI tradicional" || this.authvalue === "CI con chip";
				if (requiereCaptcha) {
					try {
						this.recaptchaToken = await this.obtenerTokenRecaptcha();
						if (!this.recaptchaToken) {
							throw new Error("No se recibió el token de reCAPTCHA");
						}
					} catch (error) {
						console.error(error);
						this.$toast.add({severity: "error", summary: "Error en la autenticación", detail:
							"No fue posible realizar la verificación reCAPTCHA", life: 3000
						});

					this.wait = false;
					return;
					}
				}
				localStorage.clear();
				this.smartService.setAmbiente();
				if (this.authvalue === 'CI con chip' && this.id.length !== 9) {
					this.$toast.add({
					severity: 'error',
					summary: 'Error en la autenticación',
					detail: 'El identificador del dorso debe tener 9 caracteres',
					life: 3000
				});
					this.wait = false;
					return;
				}
				if (this.authvalue === 'CI tradicional' && this.folio.length !== 6) {
					this.$toast.add({
					severity: 'error',
					summary: 'Error en la autenticación',
					detail: 'El N° de folio debe tener 6 caracteres',
					life: 3000
				});
					this.wait = false;
					return;
				}
				if (this.authvalue=='CI con chip' && this.ci1 != "" && this.id != "") {
					this.smartService.autenticar(this.ci1.toString(), this.id.toUpperCase(), "0", 1,this.recaptchaToken).then(token => {        	
						if(token!=null) {
							localStorage.token = token;
							localStorage.level = 1;
							localStorage.cedula = this.ci1.toString();
							this.$router.replace({ name: "Datos personales" });
						} else {
							this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Número de documento y/o identificador del dorso incorrecto', life: 3000});
						}
						this.wait=false;
					})
					.catch((e) => {
						console.log(e);
						this.wait=false;            	
						this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Ha ocurrido un error al comunicarse con el servidor', life: 3000});
						});
				}
				else if (this.authvalue=='CI tradicional' && this.ci2 != "" && this.serie != "" && this.folio != "") {
					this.smartService.autenticar(this.ci2.toString(), this.folio.toString(), this.serie.toString(), 0, this.recaptchaToken).then(token => {        	
						if(token!=null) {
							localStorage.token = token;
							localStorage.level = 1;
							localStorage.cedula = this.ci2.toString();
							this.$router.replace({ name: "Datos personales" });
						} else {
							this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Número de documento y/o identificador del dorso incorrecto', life: 3000});
						}
						this.wait=false;
					})
					.catch((e) => {
						console.log(e);
						this.wait=false;            	
						this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Ha ocurrido un error al comunicarse con el servidor', life: 3000});
						});
				}
				else if (this.authvalue=='ID Uruguay') {
					window.location = localStorage.urlIDUruguay+"/authorize?"+
					"client_id="+localStorage.client_id+
					"&redirect_uri="+encodeURIComponent(localStorage.urlLogin)+
					"&scope=openid%20personal_info%20document%20email%20auth_info"+
					"&response_type=code"+
					"&response_mode=query";
					/* this.smartService.autenticar("37317064", "00000S2W9", "0").then(token => {        	
						localStorage.token = token;
						//CAMBIAR ajuste para probar nivel cuando no se levanta usuario gub.uy
						localStorage.level = 2;
						this.$router.replace({ name: "Datos personales" });
						this.wait=false;
					}) */	
				} 				
				else {
					this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Debe ingresar número de documento e identificador ', life: 3000});
					this.wait=false;
				}
			},

			async loginTecnico(){
				this.wait= true;
				if (this.user != "" && this.pass != "" && this.ci != ""){
					await this.smartService.autenticarTecnico(this.user, this.pass, this.ci).then(token => {        	
						if(token!=null && token != "") {
							localStorage.token = token;
							localStorage.cedula = this.ci;
							localStorage.nombre = "";
							localStorage.level = 2;
							this.$router.replace({ name: "Datos personales" });
						} else {
							this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Usuario y/o contraseña incorrecto', life: 3000});
						}
						this.wait=false;
					})
					.catch((e) => {
						console.log(e);
						this.wait=false;            	
						this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Ha ocurrido un error al comunicarse con el servidor', life: 3000});
					}); 
				}
				else{
					this.$toast.add({severity:'error', summary: 'Error en la autenticación', detail: 'Debe ingresar ci, usuario y contraseña ', life: 3000});
					this.wait=false;
				}
			}
	}
};
</script>
